var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../interface/IVueDialog";
import ClientService from '../../api/ClientService';
var Settings = (function (_super) {
    __extends(Settings, _super);
    function Settings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.client = null;
        _this.config = {};
        return _this;
    }
    Settings.prototype.created = function () {
        this.service = ClientService.getInstance();
        this.client.canEdit = true;
        this.config = {
            sendNumCanEdit: 0,
            showOrderPrice: 1,
            orderPriceCanEdit: 0,
            sendOrderIsBatch: 1,
            directOrderIsBatch: 0,
            canAccount: 1,
            canDateAccount: 0,
            supplierQuote: 1,
        };
    };
    Settings.prototype.mounted = function () {
        this.$refs.main.style.height = document.documentElement.clientHeight - 180 + 'px';
    };
    Settings.prototype.close = function () {
        this.$closeDialog();
    };
    Settings.prototype.save = function () {
        this.close();
    };
    Settings = __decorate([
        Component
    ], Settings);
    return Settings;
}(VueDialog));
export default Settings;
